import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../CustomButton';
import '../../common/MobileGridCards.sass';

const MobileAssetCard = ({
	row,
	selectedAssets,
	selectAssets,
	editVehicle,
	formatGroup,
	formatOnlineStatusLocal,
	formatProfileName,
	formatDataUsageLocal,
	formatChannelStatus,
	formatStreamDataUsage,
	formatSDWearLevel,
	formatTimestamp,
	handleFailureChannelClick,
	auditLogFormatter,
	configAuditLogFormatter,
}) => {
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.manageAssetsContainer' });

	const selected = selectedAssets.includes(row.device_id);
	const nameLabel = row.vehicle_name || t('btnUnnamed');
	const statusValue = formatOnlineStatusLocal(row.status, row, true);

	const baseData = [
		{ label: t('labelDeviceID'), value: row.device_id },
		{ label: t('labelSettingsProfile'), value: formatProfileName(row.uploaded_company_profile, row) },
		{ label: t('labelCameraStatus'), value: formatChannelStatus(row.channel_status, row, handleFailureChannelClick) },
	];

	const additionalData = [
		{ label: t('labelGroupName'), value: formatGroup(row.group_name, row) },
		{ label: t('labelFirstConnected'), value: row.activated_timestamp ? formatTimestamp(`${row.activated_timestamp}+00`, true) : row.activated_timestamp },
		{ label: t('labelDataUsage'), value: formatDataUsageLocal(row.data_usage, row) },
		{ label: t('labelLiveStreamDataUsage'), value: formatStreamDataUsage(row.data_usage_live_stream, row) },
		{ label: t('labelLicensePlateNumber'), value: row.tag_plate },
		{ label: t('labelIMEI'), value: row.serial_number },
		{ label: t('labelSDWearLevel'), value: formatSDWearLevel(row.sd_wear) },
	];

	const logLinks = [
		auditLogFormatter(null, row),
		configAuditLogFormatter(null, row),
	];

	return (
		<Card className="mobile-grid-card mobile-accordion-card asset-card">
			<Card.Body>
				<div className="mobile-card-header">
					<input
						type="checkbox"
						checked={selected}
						onChange={() => selectAssets(row)}
						disabled={!row.activated_timestamp}
						className="mobile-card-checkbox"
					/>
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{value}</span>
							</div>
						))}
					</div>
					<div className="mobile-card-status">{statusValue}</div>
				</div>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header className="mobile-card-toggle" />
						<Accordion.Body>
							{!!additionalData.length && (
								<div className="mobile-card-data">
									{additionalData.map(({ label, value }) => (
										<div className="mobile-card-data-item" key={label}>
											<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
										</div>
									))}
								</div>
							)}
							{!!logLinks.length && (
								<div className="asset-log-links">
									{logLinks.map((link, i) => (
										<div className="mobile-card-data-item" key={i}>
											{link}
										</div>
									))}
								</div>
							)}
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	);
};

export default MobileAssetCard;
